import { FC } from 'react'
import styles from './Press.module.scss'
import { PressProps } from './types'
import { Img } from 'components/basic/Img'
import { Button } from 'components/Phantom/Button'

export const Press: FC<PressProps> = (props) => {
	const {} = props
	return (
		<div className={styles.container}>
			<header>
				<h2>Press</h2>
				<p>
					For any press opportunities, please contact us at<a href="mailto:press@eightsleep.com">press@eightsleep.com</a>
				</p>

				<Button.White
					id={'press-download'}
					href="https://drive.google.com/file/d/1nzgN91YXb6d5EjecHZoeY3iY5OyaseOG/view?usp=sharing"
				>
					Download Press Kit
				</Button.White>
			</header>

			<Img
				src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/press_hero.jpg"
				alt="Pod 4"
				objectFit="cover"
				dprHeight={1000}
			/>
		</div>
	)
}
